<template>
    <row :justify="mobile ? 'center' : 'start'" class="items-center">
        <column :align="mobile ? 'center' : 'start'"
                :key="index"
                xs="full"
                shrink v-for="(client, index) in clients"
                class="xs:my-4 sm:my-4 md:my-4"
                style="filter: opacity(0.5)"
        >
<!--            :style="{ 'max-height': client.size + 'px' }"-->
            <img :alt="client.src.replace('.png', '')"
                 :src="requireSrc(client.src)"
                 class="mx-4"
                 style="filter: grayscale(100%)"
                 :style="{ 'height': client.size + 'px' }"
            >
        </column>
    </row>
</template>

<script>
    export default {
        name: "CurrentClients",
        props: {
            clients: {type: Array, required: true}
        },
        data: () => ({
            logos: null
        }),
        components: {
            row: () => import('@/components/display/Row.vue'),
            column: () => import('@/components/display/Col.vue'),
        },
        computed: {
            mobile() {
                return outerWidth <= parseInt(this.$theme.screens.sm.min.replace('px', ''));
            }
        },
        methods: {
            requireSrc(src) {
                return require('@/assets/logos/' + src);
            },
            getLogos() {
                // this.$contentful.getAssets({query: {name: 'logo'}}).then(
                //     (assets) => {
                //         // console.log(assets);
                //     }
                // );
            }
        },
        mounted() {
            // this.getLogos();
        }
    }
</script>

<style scoped>

</style>
